'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { Button } from '@common/components';
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
interface EmptySectionProps {
  className?: string;
}
export const EmptySection = t0 => {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex-1 flex-col gap-16 text-center font-400 text-Gray-550 flex-center typo-body2", "mobile-tablet:typo-body3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <br />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button dimensions="H48" theme="sub-line" asChild={true} className="rounded-small"><CustomLink className="gap-6" href={DONATION_ROUTES.HOMETOWNS_BUSINESS.pathname} aria-label={"\uC9C0\uC815\uAE30\uBD80 \uBAA9\uB85D \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"}>지정기부 보러가기<SvgChevronright className="size-16 text-Gray-600" /></CustomLink></Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <section className={t1}>아직 기부내역이 없어요.{t2}따뜻한 나눔에 함께 참여해 보세요.{t3}</section>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};